import WizardSummary from '../../../../../../../common/wizard/WizardSummary.jsx'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import useAccountType from '../../../../../../../hooks/useAccontType.js'
import { useQueryClient } from '@tanstack/react-query'
import { MAIN_REJESTR_API_SHORT } from '../../../../../../../utils/consts.js'
import {Alert} from "react-bootstrap";

export const Podsumowanie = (props) => {
    const queryClient = useQueryClient()
    const { tryb } = useParams()
    const { id, wzor } = useSelector((store) => store.wizard)
    const [accountType] = useAccountType()
    const { wersja } =
        queryClient
            .getQueryData([
                `datatable_data__/oper/${MAIN_REJESTR_API_SHORT}/lista`,
            ])
            ?.list?.find((i) => i.id === id) || {}

    const hasErrors = Object.keys(props?.wiz?.summary?.error || {}).length > 0

    return (
        <>
            <WizardSummary
                failed={'Wystąpił błąd podczas walidacji danych.'}
                loading={'Walidowanie danych...'}
                success={'Dane zwalidowane poprawnie.'}
                wiz={props.wiz}
                // pdfButton={tryb === 'edycja'}
                module={'rejestr'}
                pdfBodyData={{
                    id,
                    userType: accountType,
                    wzor: wzor ?? 'or1',
                    tmp: tryb === 'edytuj' ? 'tmp' : null,
                    table: 'plan_harm',
                    wersja: wersja ?? 1,
                }}
            />
            {tryb === 'edycja' && !hasErrors && (
                <Alert variant="info" className="mt-3">
                    <i className="bi bi-info-circle me-2"></i>
                    Po wybraniu opcji <strong>"Złóż harmonogram"</strong> możliwość edycji dokumentu zostanie zablokowana.
                </Alert>
            )}
        </>
    )
}

Podsumowanie.propTypes = {
    wiz: PropTypes.any,
}
